export const invoicesMisc = {
  sendLink: {
    title: "Enviar link da fatura",
    already: {
      title: "Esta reserva já tem uma fatura emitida.",
      onlyOne: "É permitida apenas <b>1 fatura por reserva</b>.",
      offerPdf:
        "Se quiser, podemos enviar o PDF da fatura agora mesmo pelo WhatsApp.",
    },
    openPdf: "Abrir PDF",
    sendWhatsapp: "Enviar fatura pelo WhatsApp",
    sending: "Enviando...",
    info: {
      title: "O link da fatura será enviado ao hóspede pelo WhatsApp.",
      desc: "O hóspede preencherá seus dados fiscais a partir do link e poderá baixar sua fatura eletrônica.",
    },
    rule: "<strong>Regra:</strong> apenas <b>1 fatura por reserva</b> pode ser emitida.",
    accept: "Aceitar e enviar",
    toast: {
      invoiceSent: "Fatura enviada pelo WhatsApp.",
      linkSent: "Link da fatura enviado pelo WhatsApp.",
    },
    warn: {
      noReservation: "O ID da reserva ainda não foi encontrado.",
    },
    err: {
      sendInvoiceFailed: "Não foi possível enviar a fatura pelo WhatsApp.",
      sendLinkFailed: "Não foi possível enviar o link.",
    },
  },
  country: {
    placeholder: "Selecione um país (opcional)",
    noResult: "Nenhum resultado",
  },
  adjust: {
    title: "Ajustar {name}",
    type: {
      apartment: "Apartamento(s)",
      hotel: "Hotel (Quartos)",
      villa: "Villas",
      camping: "Campings",
      default: "Acomodações",
    },
    usage: "Uso atual",
    available: "Disponível",
    unitDefault: "unidades",
    hintReduce:
      "A redução se aplica agora e <b>não</b> gera reembolso. Você pagará menos na sua próxima fatura.",
    unitPriceCurrent: "Preço unitário atual",
    totalBeforeProration: "Total (antes do rateio)",
    prorationNote:
      "Será aplicado um <b>rateio</b> pelos dias decorridos no ciclo.",
    confirmIncrease: "Confirmar aumento",
    confirmDecrease: "Confirmar redução",
    err: {
      selectAmount: "Selecione uma quantidade para ajustar.",
      failed: "Não foi possível concluir a operação.",
    },
    toast: {
      added: "Unidades adicionadas",
      reduced: "Unidades reduzidas",
      addedDetail: "Será aplicado um rateio pelos dias restantes do ciclo.",
      reducedDetail: "Você pagará menos na sua próxima fatura (sem reembolso).",
    },
  },
  menu: {
    title: "Minha Assinatura",
    subtitle: "Gerencie suas assinaturas, faturas e formas de pagamento",
    subscription: "Minha assinatura",
    paymentMethod: "Forma de pagamento",
    invoices: "Faturas",
  },
  custom: {
    title: "Plano Personalizado",
    whatDoYouNeed: "Do que você precisa?",
    salesContact:
      "Nossa equipe de vendas entrará em contato com você o mais breve possível.",
    tellUs: "Conte-nos mais sobre o seu projeto",
    sentOk: "Enviado com sucesso",
    salesContactShort:
      "A equipe de vendas entrará em contato o mais breve possível",
    contactSales: "Falar com vendas",
    err: {
      required:
        "Você precisa especificar do que precisa para que possamos entrar em contato com você",
      failed: "Desculpe, não foi possível processar a solicitação",
    },
  },
  common: {
    cancel: "Cancelar",
    close: "Fechar",
  },
};
